// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_38SHaKahwAVxm0oU2bIvvx","wrap":"_37bDLeutgu7VWMRa0lEyh5","preloader":"CcXAzCruJNQGgHr0ktP7d","label":"_1QFhMZ_szzgcI5xAGTFNnj"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/components/sensitiveOverlay.scss
// module id = 2782
// module chunks = 0